(function () {
    'use strict';

    angular.module('pages.accessibility').component('colorContrastTool', {
        templateUrl: 'app/pages/accessibility/tools/color-contrast-tool/color-contrast-tool.html',
        controllerAs: 'vm',
    });
})();
